import styled from 'styled-components';

const TotalSalesStyled = styled.div`
  background: #ffffff;
  margin-top: 12px;
  border-radius: 12px;
  padding: 24px 32px;
  .sales-data-wrap {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 64px;
  }
  .sales-left {
    .sales-top-wrap {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      position: relative;
      .sales-icon-wrap {
        display: flex;
        flex-direction: row;
        .sales-icon-wrap-num {
          width: 136px;
          position: relative;
          display: flex;
          flex-direction: row;
        }
        div {
          font-size: 18px;
          font-family: 'SourceHanSansCNMedium', sans-serif;
          /* font-family: CenturyGothic; */
          color: #424242;
          margin-left: 12px;
          font-weight: 500;
          line-height: 27px;
        }
      }
      .sales-evol-wrap {
        display: flex;
        flex-direction: column;
        gap: 15px;
        .sales-evol-wrap-top {
          display: flex;
          gap: 21px;
          align-items: flex-end;
          justify-content: space-between;
        }
        .amount-tag-wrap {
          /* font-size: 29px; */
          font-weight: bold;
          color: #1d8fc0;
          line-height: 36px;
          /* width: 100%; */
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 164px;
        }
        .amount-tag-wrap-bottom {
          display: flex;
          justify-content: space-between;
          width: 166px;
        }
        .amount-content-wrap {
          display: flex;
          justify-content: space-between;
          /* min-width: 97px; */
          word-break: keep-all;
          width: 113px;
        }
        div {
          .amount-tag {
            font-size: 36px;
            text-align: right;
            float: right;
            font-family: CenturyGothic-Bold, Century Gothic;
            font-weight: bold;
            color: #1d8fc0;
            display: flex;
            flex-direction: row;
            position: relative;
          }
          .amount-tag-rmb {
            color: #1d8fc0;
            font-size: 18px;
            font-family: CenturyGothic-Bold, Century Gothic;
            font-weight: bold;
            color: #1d8fc0;
            line-height: 22px;
          }
          .amount-paa,
          .amount-paa-num {
            font-weight: bold;
            color: #424242;
            /* line-height: 22px; */
          }
          .amount-paa {
            font-size: 16px;
            font-family: 'SourceHanSansCNRegular', sans-serif;
            font-weight: 400;
            color: #424242;
            line-height: 24px;
            display: flex;
            flex-direction: row;
            position: relative;
          }
          .amount-paa-num {
            font-size: 18px;
            /* font-family: 'MontserratMedium', sans-serif; */
            font-family: CenturyGothic-Bold, Century Gothic;
            font-weight: bold;
            color: #424242;
            line-height: 22px;
          }
          .percent-up {
            color: #4caf50;
          }
          .percent-down {
            color: #ff9800;
          }
          .percent-up,
          .percent-down {
            text-align: right;
            /* width: 100%; */
            display: flex;
            justify-content: end;
            align-items: center;
            font-family: CenturyGothic-Bold, Century Gothic;
            /* font-family: 'MontserratRegular', sans-serif; */
          }
        }
        .amount-evol {
          font-size: 14px;
          color: #424242;
          line-height: 22px;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .amount-number {
          text-align: right;
        }
        .amount-percent {
          text-align: right;
          font-size: 18px;
          line-height: 22px;
        }
      }
    }
    .sales-bottom-wrap {
      /* padding-left: 27px; */
      margin-left: 34px;
      height: 37px;
      position: relative;
      .member-percent {
        display: flex;
        justify-content: space-between;
        margin: 31px 0 3px;
        span {
          display: flex;
          font-family: CenturyGothic-Bold, Century Gothic;
          /* font-family: 'MontserratRegular', sans-serif; */
          font-size: 14px;
          div {
            font-family: 'SourceHanSansCNRegular', sans-serif;
          }
        }
      }
      .progress-wrap {
        width: 100%;
        height: 12px;
        bottom: 0;
        position: absolute;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }
  .sales-right {
    position: relative;
    /* width: 832px; */
    flex: 1 auto;
    /* height: 192px; */
    /* margin-left: 82px; */
    /* padding: 30px 24px 30px 82px; */
    overflow: hidden;
  }
`;

export default TotalSalesStyled;
